module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-di-3ec19fef.png";